
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
// import GraphConsents from "./components/graph-consents.vue";
// import ConsentsToday from "./components/consents-today.vue";
// import LastSevenDays from "./components/last-seven-days.vue";
import TableConsents from "./components/table-consents.vue";

export default defineComponent({
  name: "site-consents",

  props: {
    account: { type: Object, required: true },
  },

  components: {
    // GraphConsents,
    // ConsentsToday,
    // LastSevenDays,
    TableConsents,
  },

  setup() {
    onMounted(async () => {
      setCurrentPageTitle("Consentimentos");
    });
  },
});
